import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEyeOpen = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 25 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_164_252)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M1.9375 12.5C1.9375 12.5 5.9375 4.5 12.9375 4.5C19.9375 4.5 23.9375 12.5 23.9375 12.5C23.9375 12.5 19.9375 20.5 12.9375 20.5C5.9375 20.5 1.9375 12.5 1.9375 12.5Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M12.9375 15.5C14.5944 15.5 15.9375 14.1569 15.9375 12.5C15.9375 10.8431 14.5944 9.5 12.9375 9.5C11.2806 9.5 9.9375 10.8431 9.9375 12.5C9.9375 14.1569 11.2806 15.5 12.9375 15.5Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_164_252",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white",
			transform: "translate(0.9375 0.5)"
		})
	}) })]
});
export default SvgEyeOpen;
